import { useEffect } from 'react';
import { EventDataHandler } from '../../shared';

// Interface to match any action that supports load/unload (at least one of).
export type ActionLoadUnload = {
  loadViewPage: EventDataHandler;
  unloadViewPage: EventDataHandler;
} & {
  loadViewPage: EventDataHandler;
} & {
  unloadViewPage: EventDataHandler;
};

/**
 * useTrackLoadUnload provides a way to easily hook into tracking when a page
 * is loaded/unloaded.
 * @param actions Action map that contains the load/unload actions
 */
export const useTrackLoadUnload = (actions: ActionLoadUnload, tags?: any) => {
  const dataObject = tags ? ({} as any) : undefined;
  if (dataObject) {
    dataObject.tags = tags;
  }
  useEffect(() => {
    const unload = () => {
      actions.unloadViewPage?.(dataObject);
    };
    actions.loadViewPage?.(dataObject);
    window?.addEventListener('beforeunload', unload);
    return () => {
      window?.removeEventListener('beforeunload', unload);
      unload();
    };
    // Needs to be investigated by: https://jira.cengage.com/browse/IAM-1219
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};
